import React, { useCallback, useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../../App.css";
import "./Introduction.css";
import TextSpan from "../TextSpan/TextSpan";
export const Introduction = () => {
  const FADE_INTERVAL_MS = 875;
  const WORD_CHANGE_INTERVAL_MS = FADE_INTERVAL_MS * 2;
  const WORDS_TO_ANIMATE = [
    "Software engineer 👨‍💻",
    "Full-Stack  Developer",
    "Web Developer 🧑🏻‍💻",
    "I build Software Products 💻",
    // "Crazy programmer 😉",
    "Web3 Developer 😉",
  ];

  // const [mousePosition, setMousePosition] = useState({
  //   x: 0,
  //   y: 0,
  // });

  // const [cursorVariant, setCursorVariant] = useState("default");

  // useEffect(() => {
  //   const mouseMove = (e) => {
  //     setMousePosition({
  //       x: e.clientX,
  //       y: e.clientY,
  //     });
  //   };

  //   window.addEventListener("mousemove", mouseMove);

  //   return () => {
  //     window.removeEventListener("mousemove", mouseMove);
  //   };
  // }, []);

  // const variants = {
  //   default: {
  //     x: mousePosition.x - 12,
  //     y: mousePosition.y - 12,
  //   },
  //   text: {
  //     height: 70,
  //     width: 70,
  //     x: mousePosition.x - 55,
  //     y: mousePosition.y - 55,
  //     backgroundColor: "#ccd6f6",
  //     mixBlendMode: "difference",
  //   },
  // };

  // const textEnter = () => setCursorVariant("text");
  // const textLeave = () => setCursorVariant("default");

  const [fadeProp, setFadeProp] = useState({ fade: "fade-in" });
  const [wordOrder, setWordOrder] = useState(0);

  useEffect(() => {
    const fadeTimeout = setInterval(() => {
      fadeProp.fade === "fade-in"
        ? setFadeProp({ fade: "fade-out" })
        : setFadeProp({ fade: "fade-in" });
    }, FADE_INTERVAL_MS);

    return () => clearInterval(fadeTimeout);
  }, [fadeProp]);

  useEffect(() => {
    const wordTimeout = setInterval(() => {
      setWordOrder(
        (prevWordOrder) => (prevWordOrder + 1) % WORDS_TO_ANIMATE.length
      );
    }, WORD_CHANGE_INTERVAL_MS);

    return () => clearInterval(wordTimeout);
  }, []);

  const sentence = "Assegid Assefa".split("");

  return (
    <div className="flex justify-center items-center pb-16 mb-56 md:mb-0 md:pb-0">
      <div className="w-4/5 flex flex-col gap-6  text-left">
        <h1 className="text-green-200 pt-5 md:pt-0 animate__animated animate__lightSpeedInRight animate__delay-1s">
          Hi 👋🏻, my Name is
        </h1>
        {/* <h1
          className="text-4xl md:text-7xl md:w-3/5 text-[#ccd6f6] animate__animated animate__lightSpeedInRight animate__delay-1s"
        >
          Assegid Assefa
        </h1> */}

        <div className="animate__animated animate__lightSpeedInRight animate__delay-1s">
          {sentence.map((letter, index) => {
            return (
              <TextSpan key={index}>
                {letter === " " ? "\u00A0" : letter}
              </TextSpan>
            );
          })}
        </div>
        <h2 className="text-white text-3xl md:text-6xl">
          <span
            // className="text-4xl md:text-7xl text-[#ccd6f6]"
            className={fadeProp.fade}
            // onMouseEnter={textEnter}
            // onMouseLeave={textLeave}
            // className={`${fadeProp.fade} text-4xl md:text-7xl text-[#ccd6f6]`}
          >
            {WORDS_TO_ANIMATE[wordOrder]}
          </span>
        </h2>
        {/* <motion.div
          className="cursor z-[100000]"
          variants={variants}
          animate={cursorVariant}
        /> */}
        <h1 className="text-md text-gray-500 md:w-2/3 w-full animate__animated animate__heartBeat">
          "Experienced full stack developer skilled in both front-end and
          back-end development, as well as a proficient web 3.0 developer
          specializing in blockchain technology and smart contract programming."
        </h1>
        <div className=" md:w-1/5 w-[180px] mb-24 md:mb-0 py-2 flex items-center animate__animated animate__jackInTheBox justify-center border-2 text-green-300 border-green-300 text:xs md:text-sm font-mono md:py-4 px-3 rounded-md">
          <span className="text-sm md:text-md">Check out my Work</span>
        </div>
      </div>
    </div>
  );
};
